import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex items-center" }
const _hoisted_2 = ["title"]
const _hoisted_3 = {
  key: 0,
  class: "font-bold"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["p-4 mt-6 z-20 shadow-xl flex justify-between items-center", {
      'fixed -top-6 mt-0 left-0 w-full': _ctx.fixed,
      'text-nucleus-white bg-nucleus-error': !_ctx.warning,
      'text-nucleus-black bg-nucleus-warning': _ctx.warning,
    }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(["p-2 icon-close cursor-pointer rounded-full font-bold mr-4 h-8 w-8", {
          'text-nucleus-error bg-nucleus-white': !_ctx.warning,
          'text-nucleus-warning bg-black': _ctx.warning,
        }]),
        title: _ctx.$t('titles.close'),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeError()))
      }, null, 10, _hoisted_2),
      _createElementVNode("div", null, [
        (_ctx.heading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.heading), 1))
          : _createCommentVNode("", true),
        (_ctx.content)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass({
            'font-bold': !_ctx.heading,
            'text-sm': _ctx.heading,
          })
            }, _toDisplayString(_ctx.content), 3))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", {
      class: "w-28 underline font-bold cursor-pointer p-2 justify-self-end",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.closeError()))
    }, _toDisplayString(_ctx.warning ? _ctx.$t("titles.close") : _ctx.$t("global.defaults.closeError")), 1)
  ], 2))
}